function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.24264 7.22839L0.292893 2.27864C-0.0976311 1.88812 -0.0976311 1.25495 0.292893 0.864426C0.683418 0.473902 1.31658 0.473902 1.70711 0.864426L6.65685 5.81417L11.6066 0.864426C11.9971 0.473902 12.6303 0.473902 13.0208 0.864426C13.4113 1.25495 13.4113 1.88812 13.0208 2.27864L8.07107 7.22839L13.0208 12.1781C13.4113 12.5687 13.4113 13.2018 13.0208 13.5923C12.6303 13.9829 11.9971 13.9829 11.6066 13.5923L6.65685 8.6426L1.70711 13.5923C1.31658 13.9829 0.683418 13.9829 0.292893 13.5923C-0.0976311 13.2018 -0.0976311 12.5687 0.292893 12.1781L5.24264 7.22839Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/CancelIconV2.98f1b17b.svg";
export { SvgComponent as ReactComponent };